import { render, staticRenderFns } from "./DeButton.vue?vue&type=template&id=2f758a6e&scoped=true&"
import script from "./DeButton.vue?vue&type=script&lang=js&"
export * from "./DeButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f758a6e",
  null
  
)

export default component.exports